import { render } from "./PR4-060122.vue?vue&type=template&id=00a2cf7a"
import script from "./PR4-060122.vue?vue&type=script&lang=js"
export * from "./PR4-060122.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__